module.exports = __webpack_public_path__ + "static/img/total-lineDev.56e3489b.png";